import { PropsWithChildren } from 'react'
import MDEditor from '@uiw/react-md-editor'
import FaqGroupSelect from '../FaqGroupSelect'
import { IArticleFormArticle } from '../../faq.types'
import Card from '../../../../../shared/Cards/Card'
import Toggle from '../../../../../shared/Inputs/Toggle'
import TextField from '../../../../../shared/Forms/TextField'
import TextInput from 'shared/Inputs/TextInput'
import NumberInput from '../../../../../shared/Inputs/NumberInput'
import FaqCheckpointSelect from '../FaqCheckpointsSelect'
import FaqRolesSelect from '../FaqRolesSelect'
import { IProjectCheckpoint } from 'screens/Admin/ProjectCheckpoints/projectCheckpoints.types'
import { IProjectStage, IProjectType } from 'screens/Admin/ProjectTypes/projectTypes.types'
import FaqProjectTypeSelect from '../FaqProjectTypeSelect'
import FaqProjectStageSelect from '../FaqProjectStageSelect'

interface IProps {
  article: IArticleFormArticle
  checkpointsOptions: IProjectCheckpoint[]
  projectStagesOptions: IProjectStage[]
  projectTypesOptions: IProjectType[]
  onChange: (value: any, name: string) => void
}

const EditArticleSheet = (props: PropsWithChildren<IProps>) => {
  return (
    <Card type='normal'>
      <div className='flex-lines'>
        <TextField header='Активна'>
          <Toggle name='active' checked={props.article.active} onChange={props.onChange} />
        </TextField>
        <TextField header='Заголовок'>
          <TextInput value={props.article.title} name='title' onChange={props.onChange} />
        </TextField>
        <div className='grid-form-2' style={{ gridTemplateColumns: '2fr 1fr' }}>
          <TextField header='Категория'>
            <FaqGroupSelect value={props.article.categoryId} name='categoryId' onChange={props.onChange} />
          </TextField>
          <TextField header='Положение в списке'>
            <NumberInput value={props.article.ordering} onChange={props.onChange} name='ordering' />
          </TextField>
        </div>
        <div className='flex-lines'>
          <TextField header='Тип проекта *'>
            <FaqProjectTypeSelect
              options={props.projectTypesOptions}
              value={props.article.projectTypeId}
              name='projectTypeId'
              onChange={props.onChange}
            />
          </TextField>
          <TextField header='Этап проекта *'>
            <FaqProjectStageSelect
              options={props.projectStagesOptions}
              value={props.article.projectStageId}
              onChange={props.onChange}
              name='projectStageId'
            />
          </TextField>
        </div>
        <div className='flex-lines'>
          <TextField header='Контрольные точки'>
            <FaqCheckpointSelect
              options={props.checkpointsOptions}
              value={props.article.relatedCheckpoints}
              name='relatedCheckpoints'
              onChange={props.onChange}
            />
          </TextField>
          <TextField header='Роли'>
            <FaqRolesSelect
              value={props.article.relatedProjectRoles}
              onChange={props.onChange}
              name='relatedProjectRoles'
            />
          </TextField>
        </div>
        <MDEditor height='450px' value={props.article.text} onChange={(text) => props.onChange(text, 'text')} />
      </div>
      {props.children}
    </Card>
  )
}

export default EditArticleSheet
